import { cn } from "@/lib/utils";
import { BRAND_LOGO_PATH } from "@/lib/brand";

/**
 * The weXare mark — the same `/icon.svg` the browser tab shows. Public surfaces
 * used to hand-roll a purple "wX" tile instead, so a logged-out visitor saw a
 * placeholder where the brand should be.
 */
export function BrandMark({ className }: { className?: string }) {
  return <img src={BRAND_LOGO_PATH} alt="" aria-hidden="true" className={cn("h-8 w-8 shrink-0", className)} />;
}
